import { BaseError } from '../../core/errors/BaseError.js';
import { ErrorType } from '../../core/consts.js';

class AdapterManager {
    constructor() {
        this.constructors = new Map();
    }
    setAdapter(type, constructor) {
        this.constructors.set(type, constructor);
    }
    setDynamicAdapter(adapter) {
        for (const key of Object.keys(adapter)) {
            // @ts-ignore
            this.setAdapter(key, adapter[key]);
        }
    }
    getConstructor(ctx, type) {
        if (!this.constructors.has(type)) {
            throw new BaseError({
                ctx,
                type: ErrorType.NoAdapter,
                msg: `adapter not exist for ${type}`,
                sender: this
            });
        }
        return this.constructors.get(type);
    }
    static setAdapter(type, constructor) {
        return this.Instance.setAdapter(type, constructor);
    }
    static getConstructor(ctx, type) {
        return this.Instance.getConstructor(ctx, type);
    }
    static setDynamicAdapter(adapter) {
        return this.Instance.setDynamicAdapter(adapter);
    }
}
// static wrapper
AdapterManager.Instance = new AdapterManager();

export { AdapterManager };
//# sourceMappingURL=AdapterManager.js.map
